"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setItem = exports.removeItem = exports.getItem = exports.default = exports.LOCAL_STORAGE_EVENT = void 0;
var _isBrowser = _interopRequireDefault(require("../isBrowser"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const LOCAL_STORAGE_EVENT = exports.LOCAL_STORAGE_EVENT = 'w-local-storage-change';
const setItem = (key, value) => {
  if (!(0, _isBrowser.default)() || !key) return {};
  const newValue = {
    [key]: value
  };
  window.localStorage.setItem(key, JSON.stringify(newValue));
  window.dispatchEvent(new CustomEvent(LOCAL_STORAGE_EVENT, {
    detail: {
      key,
      newValue
    }
  }));
  return newValue;
};
exports.setItem = setItem;
const getItem = key => {
  let value = {};
  if (!(0, _isBrowser.default)() || !key) return value;
  const valueStored = window.localStorage.getItem(key);
  if (valueStored) value = JSON.parse(valueStored);
  return value;
};
exports.getItem = getItem;
const removeItem = key => {
  if ((0, _isBrowser.default)() && key) {
    window.localStorage.removeItem(key);
    window.dispatchEvent(new CustomEvent(LOCAL_STORAGE_EVENT, {
      detail: {
        key,
        removed: true
      }
    }));
  }
};
exports.removeItem = removeItem;
var _default = exports.default = {
  setItem,
  getItem,
  removeItem
};